import { Component, Input, OnChanges, OnInit } from '@angular/core';

@Component({
  selector: 'colgroup[appColEvenly]',
  templateUrl: './col-evenly.component.html',
  styleUrls: ['./col-evenly.component.scss']
})
export class ColEvenlyComponent implements OnInit, OnChanges {
  @Input() cols = 1;

  array: any[] = [];

  constructor() { }

  ngOnInit(): void {
  }

  ngOnChanges() {
    this.array = Array(this.cols);
  }
}
